import PageTitle from "components/PageTitle";
import DashboardLayout from "layout/DashboardLayout";
import SyncJobsPage from "./Internal";

export default function EmailSyncQueue() {
  return (
    <DashboardLayout>
      <PageTitle pageTitle={[{ title: "Email Sync" }]} title="Email Sync" />
      <SyncJobsPage />
    </DashboardLayout>
  );
}
